import httpAuth from '@/services/httpAuth'

import { serialize2 } from '@/services/object'

// Devices
export async function listDevice (filtros) {
  return httpAuth.get(`/seguranca/device/${serialize2(filtros)}`, { tela: 'auth_logs' })
}

export async function addDevice (device) {
  return httpAuth.post('/seguranca/device', device)
}

export async function editDevice (dados) {
  return httpAuth.put(`/seguranca/device/${dados.id}`, dados, { funcionalidade: 'seguranca_device_editar' })
}

export async function getDevice (fingerprint) {
  return httpAuth.get(`/seguranca/device/${fingerprint}`)
}

export async function delDevice (fingerprint) {
  return httpAuth.delete(`/seguranca/device/${fingerprint}`, { tela: 'seguranca_device' })
}

// Logs
export async function listLogs (filtros) {
  return httpAuth.get(`/seguranca/logs/${serialize2(filtros)}`, { tela: 'seguranca_logs' })
}

// Emails
export async function enviarEmailNovoDispositivo (device) {
  return httpAuth.post('/emails/emailnovodispositivo', device)
}

export async function validaChaveLiberacao (device) {
  return httpAuth.post('/seguranca/validachave', device)
}
